import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':jobId'}/siblingSubjobs`;

export const ROUTE: RouteDefinition = `${baseRoute}/:jobId/siblingSubjobs`;

export const URL = (jobId: number): RouteDefinition => `${baseRoute}/${jobId}/siblingSubjobs`;
